import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { RootState } from "@/store/store";
import PatientsPagination from "../PatientsPagination/PatientsPagination";
import formattedDate from "@/utils/formattedDate";
import priceFormatter from "@/utils/priceFormatter";
import { totalPriceCounter } from "@/services/API/totalPriceCounter";
import { setIsVisibleModalDialog } from "@/store/ui/ui";
import ModalDialog from "../ModalDialog/ModalDialog";
import useDeleteEntity from "@/hooks/useDeleteEntity";
import { setAppointemtId } from "@/store/schedule/scheduleSlice";
import { deleteAppointment } from "@/store/users/users";

export default function UserDetailsPageAppsList() {
    const dispatch = useDispatch();
    const [activepage, setActivePage] = useState<number>(1);
    const { handleDelete } = useDeleteEntity();

    const appointments = useSelector(
        (state: RootState) => state.users.selectedDoctor.appointments,
    );
    const appointmentId = useSelector(
        (state: RootState) => state.schedule.appointmentId,
    );

    const limitPage = 9;
    const startIndex = (activepage - 1) * limitPage;
    const endIndex = startIndex + limitPage;
    const currentAppointments = (appointments ?? []).slice(
        startIndex,
        endIndex,
    );

    function handleChangeActivepage(
        event: React.ChangeEvent<unknown>,
        value: number,
    ) {
        setActivePage(value);
    }

    const handleOpen = (id: string) => {
        dispatch(setAppointemtId(id));
        dispatch(setIsVisibleModalDialog(true));
    };

    const handleDeleteAppointment = async () => {
        const onSuccessFunc = () => {
            dispatch(deleteAppointment(appointmentId));
            dispatch(setAppointemtId(""));
            dispatch(setIsVisibleModalDialog(false));
        };
        await handleDelete({
            entity: "appointments",
            id: appointmentId,
            onSuccess: onSuccessFunc,
            message: "Візит пацієнта успішно видалено",
            isLocalLoading: true,
        });
    };

    return (
        <section className='listing_container'>
            <table className='listing_table'>
                <thead>
                    <tr>
                        <th className='listing_table-date'>Дата</th>
                        <th>Послуги</th>
                        <th className='listing_table-service'>Пацієнт</th>
                        <th className='listing_table-price'>Вартість</th>
                        <th className='listing_table-delete'></th>
                    </tr>
                </thead>
                <tbody>
                    {currentAppointments && currentAppointments.length > 0 ? (
                        currentAppointments.map(item => (
                            <tr key={item._id} className='listing_table-row'>
                                <td className='listing_table-date'>
                                    <p>
                                        {formattedDate(item.date)}{" "}
                                        <span>
                                            {item.startTime}-{item.endTime}
                                        </span>
                                    </p>
                                </td>
                                <td>
                                    <div className='listing_table-service-info'>
                                        {item.services.length > 0 ? (
                                            <>
                                                <p>{item.services[0].title}</p>
                                                {item.services.length - 1 >
                                                0 ? (
                                                    <p className='listing_table-service-info-paragraf'>
                                                        +{" "}
                                                        {item.services.length -
                                                            1}
                                                    </p>
                                                ) : null}
                                            </>
                                        ) : (
                                            <p>Послуги відсутні</p>
                                        )}
                                    </div>
                                </td>
                                <td>
                                    {item?.patientId?.name
                                        ? item.patientId.name
                                        : "Дані відсутні (пацієнта видалено)"}
                                </td>
                                <td className='listing_item-price'>
                                    {priceFormatter(
                                        totalPriceCounter(item.services),
                                    )}{" "}
                                    ₴
                                </td>
                                <td>
                                    <button
                                        className='listing_icons'
                                        onClick={e =>
                                            handleOpen(e.currentTarget.id)
                                        }
                                        id={item._id}
                                    >
                                        <img
                                            src='/patients/delete.svg'
                                            alt='delete-logo'
                                        />
                                    </button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={5} className='no-data'>
                                Записи відсутні
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
            <PatientsPagination
                localdataLength={appointments?.length}
                activepage={activepage}
                handleChangeActivepage={handleChangeActivepage}
                limitPage={limitPage}
            />
            <ModalDialog
                onConfirm={handleDeleteAppointment}
                title='Видалити візит пацієнта?'
                message={`Ви впевнені, що хочете видалити візит пацієнта ?`}
            />
        </section>
    );
}
